import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft, ChevronRight, Play } from "lucide-react";
import ExerciseDetail from './ExerciseDetail';
import Header from '../../components/Header';

const SUPABASE_PROJECT_ID = 'mosvpddcjtcbnineqzqh'; 
const BUCKET_URL = `https://${SUPABASE_PROJECT_ID}.supabase.co/storage/v1/object/public/exercise-videos`;

// Optimized Video Preview for List View
const VideoPreview = ({ path }) => {
  if (!path) return <div className="w-16 h-16 bg-gray-100 rounded-2xl" />;
  
  // Encode path and append #t=0.1 to show the first frame as a thumbnail
  const fullUrl = `${BUCKET_URL}/${path.split('/').map(s => encodeURIComponent(s)).join('/')}#t=0.1`;

  return (
    <div className="w-16 h-16 bg-black rounded-2xl overflow-hidden shadow-inner flex-shrink-0 relative">
      <video 
        src={fullUrl} 
        preload="metadata" // Only load the first frame info
        playsInline 
        muted 
        className="w-full h-full object-cover" 
      />
      <div className="absolute inset-0 bg-black/10 flex items-center justify-center">
         <Play size={12} className="text-white/40 fill-current" />
      </div>
    </div>
  );
};

const WorkoutDetail = ({ workout, onBack }) => {
  const [selectedEx, setSelectedEx] = useState(null);

  return (
    <div className="fixed inset-0 z-[60]">
      
      <motion.div
        initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }}
        className="absolute inset-0 bg-white overflow-y-auto"
      ><Header />
        <div className="relative h-80 z-10">
          
          <img src={workout.image} className="w-full h-full object-cover brightness-50" alt="" />
          <button onClick={onBack} className="absolute top-12 left-4 p-2 bg-black/20 backdrop-blur-md rounded-full text-white z-50 shadow-xl">
            <ArrowLeft size={22} />
          </button>
          <div className="absolute bottom-12 left-6 text-white">
            <h1 className="text-4xl font-black uppercase tracking-tight leading-none">{workout.name}</h1>
          </div>
        </div>

        <div className="relative z-20 p-6 pb-32 space-y-4 -mt-10 bg-white rounded-t-[40px] shadow-2xl border-t border-gray-100">
          <h3 className="text-lg font-black text-gray-800 uppercase tracking-tight mb-2">Workout Circuit</h3>

          {workout.exercises.map((ex) => (
            <motion.div
              key={ex.id}
              whileTap={{ scale: 0.96 }}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedEx(ex);
              }}
              className="flex items-center gap-4 p-4 bg-white rounded-[28px] border border-gray-100 shadow-sm cursor-pointer hover:border-blue-200 transition-all"
            >
              <VideoPreview path={ex.videoPath} />
              <div className="flex-1">
                <h4 className="font-bold text-gray-900 leading-tight">{ex.name}</h4>
                <p className="text-sm text-gray-400 font-medium">{ex.sets} Sets • {ex.reps} Reps</p>
              </div>
              <ChevronRight size={20} className="text-gray-300" />
            </motion.div>
          ))}
        </div>
      </motion.div>

      <AnimatePresence>
        {selectedEx && <ExerciseDetail exercise={selectedEx} onBack={() => setSelectedEx(null)} />}
      </AnimatePresence>
    </div>
  );
};

export default WorkoutDetail;